'use strict';

var $ = require('jquery');
var Radio = require('backbone.radio');
var moment = require('moment-timezone');
var Marionette = require('backbone.marionette');

var DayView = require('./calendar-day').default;
var EmptyView = require('./calendar-empty').default;
var TimeSelectionEvents = require('../../../analytics/time-selection-events').default;

var MAX_PAGE_SIZE = 5;
var KEYCODES = require('../../utilities/keycodes').default;

export default Marionette.CollectionView.extend({

  className: 'calendar-days',
  tagName: 'ul',
  childView: DayView,
  emptyView: EmptyView,

  childBackButton: '.calendar-day-header-back',
  childNextButton: '.calendar-day-header-next',

  childViewOptions: function () {
    return {
      appointment: this.appointment,
      calendarCollectionStart: this.start,
      calendarCollectionEnd: this.end.clone().subtract(1, 'day'),
    };
  },

  childViewEvents: {
    'click:time': 'onClickTime',
    'back': 'moveToPrevPage',
    'next': 'moveToNextPage',
  },

  initialize: function (options) {
    this.isShown = false;
    this.index = 0;
    this.appointment = options.appointment;
    this.collection = options.collection;
    this.start = options.start;
    this.end = options.end;
    this.fetchTimes = options.fetchTimes;
    this.hasActiveRequests = options.hasActiveRequests;
    this.isInitialLoad = true;
    this.staff = options.staff;

    this.listenTo(this, 'render:empty', this.onRenderEmpty);
    this.listenTo(Radio.channel('calendar-collection'), 'setInitialLoad', this.setInitialLoad);
  },

  onBeforeRender: function () {
    if (this.appointment.has('start') && typeof this.appointment.get('start') === 'string') {
      this.appointment.unset('start');
    }

    if (this.collection.length) {
      this.triggerMethod('updateBackAndNextButtons');
    }
  },

  onRender: function () {
    if (this.collection.length && this.collection.getAvailableTimeCount() > 0) {
      if (this.index < this.collection.length) {
        this.isShown = true;
        this.setInitialCurrentIndex();
        this.scrollToCurrentPage();

        if (this.appointment.has('start')) {
          var start = this.appointment.get('start');

          this.select(start.format('YYYY-MM-DD HH:mm:ss'));
        }
      }
    } else {
      $('.calendar-empty').show();
    }
  },

  onRenderEmpty: function () {
    if (this.isShown || this.appointment.isPrivate()) {
      this.children.first().show();
    }
  },

  onDomRefresh: function () {
    if (!this.appointment.has('start')) {
      var $link = $('.calendar-day-time-link').first();
      if ($link.length === 1) {
        $link.attr('tabindex', '0');
      }
    }
  },

  onClickTime: function (child, timeModel, timeString) {
    this.deselectAll();
    child.select(timeString);

    var selectedDateTime = moment.tz(timeModel.get('value') + ' ' + timeString, window.localStorage.getItem('timezone'));
    var locationDateTime = selectedDateTime.clone().tz(this.appointment.location.getTimezone());
    var locationTime = locationDateTime.clone().format('HH:mm:ss');
    var time = timeModel.getTime(locationTime);

    if (time.staff && time.staff.length > 0) {
      var random = Math.floor((Math.random() * time.staff.length));
      var staff_id = parseInt(time.staff[random].id);
      this.triggerMethod('setStaff', staff_id);
    }

    this.appointment.set('start', selectedDateTime);
    this.triggerMethod('childClickTime', timeModel, timeString);
  },

  onResize: function () {
    this.children.each(function (childView) {
      childView.updateHeight();
    });
  },

  showLoadingView: function () {
    this.triggerMethod('loading');
  },

  hideLoadingView: function () {
    // don't hide the loading view if there are still active requests
    if (this.hasActiveRequests()) return;

    this.triggerMethod('loadingDone');
  },

  setInitialCurrentIndex: function () {
    if (!this.isShown) {
      return;
    }

    if (!this.isInitialLoad) {
      return;
    }
    this.isInitialLoad = false;

    var date;
    if (this.appointment.has('start')) {
      date = moment(this.appointment.get('start'), 'YYYY-MM-DD HH:mm:ss').startOf('day');
    } else {
      var time = this.collection.findFirstWithTimes();
      if (time) {
        date = moment(time.get('value'), 'YYYY-MM-DD');
      }
    }

    if (date) {
      this.focusedDate = date.format('YYYY-MM-DD');
    }

    this.setCurrentIndex(date);
    this.setCalendarMonth();
  },

  setInitialLoad: function (value) {
    this.isInitialLoad = value;
  },

  setCurrentIndex: function (date) {
    if (date) {
      this.index = Math.round(date.clone().diff(this.start, 'days', true));
    }
  },

  getCurrentPage: function () {
    return Math.ceil(this.index / this.getPageSize()) + 1;
  },

  scrollToCurrentPage: function () {
    if (!this.isShown) {
      return;
    }

    if (this.needToLoadPages()) {
      this.loadMorePages();
      return;
    }

    this.setLeft();
  },

  loadMorePages: function () {
    this.end = this.start.clone().add(this.index + this.getPageSize(), 'days');
    this.end.add(1, 'month').startOf('month');

    this.triggerMethod('setEnd', this.end);
    this.fetchTimes(true);
  },

  select: function (datetime) {
    const [convertedDate, convertedTime, timezone] = this.getDateAndTimeForTimezone(datetime);

    var model = this.collection.findWhere({
      'value': convertedDate,
    });

    if (model) {
      var view = this.children.findByModel(model);
      if (view) {
        this.appointment.set('start', moment.tz(convertedDate + ' ' + convertedTime, timezone));
        view.select(convertedTime);
      }
    }
  },

  setCollection: function (collection) {
    this.collection = collection;
  },

  updateEnd: function (end) {
    this.end = end;
  },

  getDateAndTimeForTimezone: function (datetime) {
    var timezone = window.localStorage.getItem('timezone');
    var previousTimezone = window.localStorage.getItem('previous_timezone') || this.appointment.get('timezone');

    var selected = moment.tz(datetime, previousTimezone);
    var converted = selected.clone().tz(timezone);
    var convertedTime = converted.format('HH:mm:ss');
    var convertedDate = converted.format('YYYY-MM-DD');

    return [convertedDate, convertedTime, timezone];
  },

  deselectAll: function () {
    this.children.each(function (child) {
      child.deselectAll();
    });
  },

  getCurrentDay: function () {
    var day = this.collection.at(this.index);
    if (day) {
      return moment(day.get('value'), 'YYYY-MM-DD');
    }

    return this.start.clone();
  },

  setCalendarMonth: function () {
    var location = this.appointment.location;

    var hasTimezoneFromLocalStorage = window.localStorage.getItem('timezone') !== null;

    var timezone;
    if (location.isVirtual()) {
      timezone = hasTimezoneFromLocalStorage ? window.localStorage.getItem('timezone') : moment.tz.guess();
    } else {
      timezone = hasTimezoneFromLocalStorage ? window.localStorage.getItem('timezone') : location.getTimezone();
    }

    window.localStorage.setItem('timezone', timezone);

    var abbreviation = moment.tz(timezone).zoneAbbr();
    var timezoneHtml = ' (<a href="#" class="timezone" aria-expanded="false">' + abbreviation + '</a>)';

    var currentDate = this.getCurrentDay();
    Radio.channel('date-picker').trigger('setTimezoneHtml', timezoneHtml);
    Radio.channel('date-picker').trigger('setMonth', currentDate);
    Radio.channel('calendar').trigger('setFirstDateShown', currentDate);

    if (location.isVirtual()) {
      this.triggerMethod('showTimezonePopup', timezone, abbreviation);
    }
  },

  getPageSize: function () {
    var childView = this.children.first();

    if (this.$el && childView) {
      var containerWidth = this.$el.outerWidth(true);
      var childWidth = childView.$el.outerWidth(true);

      if (containerWidth && childWidth) {
        return Math.round(containerWidth / childWidth);
      }
    }

    return MAX_PAGE_SIZE;
  },

  getLastPageSize : function() {
    return this.collection.length - this.index;
  },

  getNumberOfPages: function () {
    var pagesBefore = Math.ceil(this.index / this.getPageSize());
    var pagesAfter = Math.ceil((this.getLastPageSize()) / this.getPageSize());

    return pagesBefore + pagesAfter;
  },

  setLeft: function () {
    this.$el.css('left', -((this.index / this.getPageSize()) * 100) + '%');
  },

  needToLoadPages: function () {
    const currentPage = this.getCurrentPage();
    const lastPageSize = this.getLastPageSize();
    const pageSize = this.getPageSize();
    const numberOfPages = this.getNumberOfPages();

    return !window.SETTINGS.time_in_advance && lastPageSize < pageSize && currentPage < numberOfPages;
  },

  moveToNextPage: function () {
    TimeSelectionEvents.trackClick('Next');
    var originalIndex = this.index;
    this.index += this.getPageSize();

    if (this.needToLoadPages()) {
      if (this.hasActiveRequests()) {
        this.index = originalIndex;
        return;
      }

      this.loadMorePages();
      return;
    }

    if (this.index >= this.collection.length) {
      this.index = this.collection.length - 1;
    }
    this.setLeft();
    this.setCalendarMonth();
  },

  moveToPrevPage: function () {
    TimeSelectionEvents.trackClick('Back');

    this.index -= this.getPageSize();
    if (this.index < 0) {
      this.index = 0;
    }
    this.setLeft();
    this.setCalendarMonth();
  },

  //KEYBOARD NAVIGATION FUNCTIONALITY

  navigateCalendar: function (keyCode) {
    if (this.collection.length === 0) {
      return;
    }
    switch (keyCode) {
      case KEYCODES.LEFT:
        this.navigateToPreviousDay();
        break;
      case KEYCODES.RIGHT:
        this.navigateToNextDay();
        break;
      case KEYCODES.UP:
        this.navigateToPreviousTime();
        break;
      case KEYCODES.DOWN:
        this.navigateToNextTime();
        break;
      default:
        break;
    }
  },

  navigateToPreviousDay: function () {
    if (this.collection.isDateFirstInCollection(this.focusedDate)) {
      return;
    }
    var dateIndex = this.collection.findIndexOfDate(this.focusedDate);
    if (dateIndex == -1) {
      return;
    }

    for (var i = (dateIndex - 1); i >= 0; i--) {
      if (this.collection.at(i).hasTimes()) {
        this.adjustCurrentFocusedDay(i);
        this.removeOldTabs(dateIndex);
        break;
      }
    }
  },

  navigateToNextDay: function () {
    if (this.collection.isDateLastInCollection(this.focusedDate)) {
      return;
    }

    var dateIndex = this.collection.findIndexOfDate(this.focusedDate);
    if (dateIndex == -1) {
      return;
    }

    for (var i = (dateIndex + 1); i <= this.collection.length - 1; i++) {
      if (this.collection.at(i).hasTimes()) {
        this.adjustCurrentFocusedDay(i);
        this.removeOldTabs(dateIndex);
        break;
      }
    }
  },

  navigateToPreviousTime: function () {
    var dayModel = this.collection.findWhere({
      'value': this.focusedDate,
    });
    if (!dayModel) {
      return;
    }
    var dayView = this.children.findByModel(dayModel);
    if (!dayView) {
      return;
    }
    dayView.navigateToPreviousTime();
  },

  navigateToNextTime: function () {
    var dayModel = this.collection.findWhere({
      'value': this.focusedDate,
    });
    if (!dayModel) {
      return;
    }
    var dayView = this.children.findByModel(dayModel);
    if (!dayView) {
      return;
    }
    dayView.navigateToNextTime();
  },

  checkCurrentPage: function () {
    var index = Math.round(moment(this.focusedDate, 'YYYY-MM-DD').clone().diff(this.start, 'days', true));
    var newPage = Math.floor(index / this.getPageSize()) + 1;
    if (newPage > this.getCurrentPage()) {
      this.triggerMethod('navigateNext');
    } else if (newPage < this.getCurrentPage()) {
      this.triggerMethod('navigateBack');
    }
  },

  adjustCurrentFocusedDay: function (dayIndex) {
    var dayModel = this.collection.at(dayIndex);
    var dayView = this.children.findByModel(dayModel);
    dayView.setFocusToFirstTime();
    this.focusedDate = dayModel.get('value');
    this.checkCurrentPage();
  },

  removeOldTabs: function (dateIndex) {
    var dayModel = this.collection.at(dateIndex);
    var dayView = this.children.findByModel(dayModel);
    dayView.removeAllTabs();
  },
});
